import type { ComponentProps } from '@enonic/react-components'
import type { RichTextData } from '@enonic/react-components'
import * as React from 'react'
import { Prose, Section, Container } from '../primitives'

export interface RichTextPartData extends Record<string, unknown> {
  body?: RichTextData
}

export const RichTextPart = (props: ComponentProps) => {
  const { body } = props.data as RichTextPartData

  if (!body) return null

  return (
    <Section>
      <Container className="">
        <Prose
          className="col-span-full md:col-span-8 md:col-start-3 prose-flush"
          data={body}
          meta={props.meta}
          common={props.common}
          component={props.component}
        />
      </Container>
    </Section>
  )
}
